export default __webpack_public_path__ + "static/media/seal.1b6b17d4.png";